function createPoint(point) {
  if (Array.isArray(point)) {
    return {
      x: point[0],
      y: point[1]
    }
  }
  return point
}

function getSelectedRange({rangeSelector}){
  const {selected} = rangeSelector || {}
  return Number.isInteger(selected) ? rangeSelector.options.buttons[selected].type : null
}

function getStartPoint(chart, series){
  //if its not the all view take the second point, for the calculation
  //TODO this can removed if we fix that the start point is not displayed left of the x axis, there we can take always the first point
  const {data} = series.options
  const selectedRange =getSelectedRange(chart)
  const all = !selectedRange || selectedRange === 'all'
  let point = null
  if(all){
    point=createPoint(data[0])
  }else{
    const {points, points:{length}} = series
    const index = length>1 ? 1 : 0
    point = points[index]
    const dataGroup=point?.dataGroup
    if(dataGroup){
      const index = dataGroup.start
      point = createPoint(data[index])
    }
  }

  return point
}


const performance = function (chart) {
  const {series} = chart

  series.forEach(series => {
    const {events, data} = series.options
    if(events?.performance) {
      const points = series.points

      if(!points?.length){
        events.performance({absolute:0, percent:0})
        return
      }
      const start = getStartPoint(chart, series)  // start point

      const lastPoint = points[points.length-1]
      const compareVal = lastPoint.change

      /*end point, always use las and not lats in plot
      * so in case you scroll or change the plot area to the past
      * the performance is over the full time range
      * Hint: move the plot to the past is not possible anymore (at the moment)
      * */
      const lastDataPoint = createPoint(data[data.length - 1])
      const end = compareVal ? lastPoint: lastDataPoint

      const startVal = start.y
      const endVal = end.y
      const absolute = compareVal || endVal - startVal // difference between first and last points "y"
      let percent = compareVal || (100 / startVal * absolute)

      if (Number.isNaN(percent)) {
        percent = 0
      }

      let longDescription = ''
      if (chart.rangeSelector && (chart.rangeSelector.selected === undefined || chart.rangeSelector.selected === 0)) {
        longDescription = chart.rangeSelector.buttonOptions[0].textLong
      } else if (chart.rangeSelector && chart.rangeSelector.selected) {
        longDescription = chart.rangeSelector.buttonOptions[chart.rangeSelector.selected].textLong
      }

      events.performance({from: new Date(start.x), to: new Date(lastDataPoint.x), start, end, absolute, percent, longDescription})
    }
  })

}

export default function (H) {
  H.addEvent(H.Chart, 'render', function (e) {
    const chart = e.target
    performance(chart)
  })
}
